import axios from "axios";
import {toast} from "react-toastify";
import {ERROR, ERROR_CODE} from "../constants/error";
import {getCookie} from "../utils";


// Helper function to create Axios instances with interceptors
const createAxiosInstance = (baseURL) => {
  const instance = axios.create({
    baseURL,
    timeout: 10000,
    headers: {
      "Content-Type": "application/json"
    },
  });

  instance.interceptors.request.use(
    (config) => {
      let token = getCookie('token');
      if (!token) token = localStorage.getItem("token");
      if (token && !config.headers["Authorization"]) {
        config.headers["Authorization"] = 'Bearer ' + token;
      }
      if (config.data && config.data instanceof FormData) {
        config.headers["Content-Type"] = "multipart/form-data";
      }
      return config;
    },
    (error) => Promise.reject(error),
  );

  return instance;
};

// Create an Axios instance
export const axiosClient = createAxiosInstance(process.env.REACT_APP_API_URL);
export const axiosClientV2 = createAxiosInstance(process.env.REACT_APP_API_URL_V2);
export const axiosClientLogin = createAxiosInstance(process.env.REACT_APP_CAS_API_URL);
export const axiosClientImage = createAxiosInstance(process.env.REACT_APP_IMAGE_API_URL);
export const axiosClientDelivery = createAxiosInstance(process.env.REACT_APP_DELIVERY_API_URL);
export const axiosClientOrder = createAxiosInstance(process.env.REACT_APP_ORDER_URL);
export const axiosClientNoti = createAxiosInstance(process.env.REACT_APP_NOTI_URL);

//Response interceptor
/*axiosClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      console.error("Response error:", error.response.data);
    } else if (error.request) {
      console.error("Request error:", error.request);
    } else {
      console.error("Error:", error.message);
    }
    return Promise.resolve(error);
  },
);*/

// Function to handle .then and .catch
export const handleRequest = (request) => {
  return request
    .then((response) => {
      return {
        data: response?.data,
        status: response?.status,
        success: response?.status === 200 || response?.status === 201,
      };
    })
    .catch((error) => {
      handleError(error);
      return {
        data: error?.response?.data,
        status: error?.response?.status || error?.status,
        success: false,
      };
    });
};

const handleError = (error) => {
  const data = error?.response?.data;
  const {code} = data || {};
  if (ERROR?.[code] && (
    code !== ERROR_CODE['AUTH_21']
  )) {
    toast.info(ERROR?.[code]);
  }
}

export default axiosClient;
